export default {
  wallet: ''
}
